###
    @author Jaromír Navara [BG] <web@bagricek.cz>
    26.8.2016 4:14
###
if !window.requestAnimationFrame
  window.requestAnimationFrame = ->
    return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame

console.log "%c\n                                                                            \n                            -/oyhdmNMMMMNmmhyo/-                            \n                       `:sdMMNhyo+::----::+oyhNMMds:`                       \n                    `/hMMds:`                  `:odMMh/`                    \n   //////////////////////////////////////////////////////////////////////   \n    ////////////////////////////////////////////////////////////////////    \n      \\\\\\\\\\\\   +NMy.                                    `sMN+   //////      \n        \\\\\\\\\\-hMm-                                        -mMd-/////        \n          \\\\MMMh`                                          `h/////          \n           `mMy                                           /////m`           \n           hMd         Proudly developed by             /////-dMh           \n          /MM-                                        //////  .MM/          \n          dMh          Space _cat                   //////     yMd          \n         `MM/                                      /////       /MM`         \n         -MM-          https://tady.eu           /////         -MM-         \n         -MM-                                  /////           -MM-         \n         `MM/                                /////             /MM`         \n          dMh                              /////               yMd          \n          /MM-                           /////                .MM/          \n           hMd                         /////                  dMh           \n           `mMy                      /////                   yMm`           \n            .mMh`                  ///\\\\\\                  `hMm.            \n             `hMm-               /////\\\\\\\\\\               -mMh`             \n               +NMy.           //////  \\\\\\\\\\\\           `yMN+               \n                `yMMs.        /////      \\\\\\\\\\         .sMMy.               \n                  .sNMd+`                          `+dMNs.                  \n                    `/hMMds:`                  `:odMMh/`                    \n                       `:sdMMNdyo+/:----::+oyhNMMds:`                       \n                            -/oyhdmNMMMMNmdhyo/-                            \n                                                                            ", "background: #2C3E50; color: #FFF; font-family: monospace;"

$ ->
  if $.nette then $.nette.init();
#  jQuery for page scrolling feature - requires jQuery Easing plugin
  $('.page-scroll a').bind 'click', (event)->
    $anchor = $(this);
    $('html, body').stop().animate({scrollTop: ($($anchor.attr('href')).offset().top - 50)},1250,'easeInOutExpo')
    event.preventDefault()

# Highlight the top nav as scrolling occurs
  $('body').scrollspy
    target: '.navbar-fixed-top',
    offset: 70

# Closes the Responsive Menu on Menu Item Click
  $('.navbar-collapse ul li a').click ->
    $('.navbar-toggle:visible').click()

  $("#mainNav").affix
    offset:
      top: $("#mainNav").outerHeight(true)

# Floating label headings for the contact form
  $("body").on "input propertychange", ".floating-label-form-group", (e) ->
    $(this).toggleClass "floating-label-form-group-with-value", !!$(e.target).val()
  .on "focus", ".floating-label-form-group", ->
    $(this).addClass "floating-label-form-group-with-focus"
  .on "blur", ".floating-label-form-group", ->
    $(this).removeClass "floating-label-form-group-with-focus"

  $(".gallery").slick
    adaptiveHeight: true
    prevArrow: $(".left.arrow")
    nextArrow: $(".right.arrow")

  $(".portfolio-modal .close-modal").click ->
    console.log("close")
    if $.featherlight then $.featherlight.current().close();
    if window.parent.$.featherlight then window.parent.$.featherlight.current().close();

  $("#portfolio .portfolio-link").click (e) ->
    e.preventDefault()
    href = $(this).attr("data-href")
    $.featherlight
      iframe: href
      iframeWidth: $( window ).width()
      iframeHeight: $( window ).height()
      afterOpen: -> window.parent.$(".loader").hide()
      resetCss: false
      beforeOpen: ->
        window.parent.$(".loader").show();
        window.parent.$('html, body').css "overflowY", "hidden"
      beforeClose: ->
        window.parent.$('html, body').css "overflowY", "auto"

  $("#portfolio .portfolio-item.hidden").removeClass("hidden").addClass("hid").slideUp(0)

  $("#portfolio .more i").click (e)->
    e.preventDefault()
    $items = $("#portfolio .portfolio-item.hid")
    $items.slice(0,3).removeClass("hid").slideDown();
    if $items.length-3 < 1 then $(this).slideUp()

  $("#contactForm").submit (e)->
    e.preventDefault()
    ga('send', 'event', 'contact-form', 'sent', $("#email").val() + " : " + $("#email").val());


  blink = false
  setInterval ->
    blink = !blink
#    console.log("opacity #{blink ? 1 : 0}")
    $(".blink").css("opacity", if blink then 0.3 else 0)
  , 500

  if($("#sky")[0])
    sky = new Sky $("#sky");
    sky.draw();
    $("#sky").fadeIn(3000);






signature = '''%c
--------------------------------------------------------------------------
|                          -/oyhdmNMMMMNmmhyo/-                          |
|                     `:sdMMNhyo+::----::+oyhNMMds:`                     |
|                  `/hMMds:`                  `:odMMh/`                  |
| ////////////////////////////////////////////////////////////////////// |
|  ////////////////////////////////////////////////////////////////////  |
|    \\\\\\\\\\\\   +NMy.                                    `sMN+   //////    |
|      \\\\\\\\\\-hMm-                                        -mMd-/////      |
|        \\\\MMMh`                                          `h/////        |
|         `mMy                                           /////m`         |
|         hMd         Proudly developed by             /////-dMh         |
|        /MM-                                        //////  .MM/        |
|        dMh          Space _cat                   //////     yMd        |
|       `MM/                                      /////       /MM`       |
|       -MM-          https://tady.eu           /////         -MM-       |
|       -MM-                                  /////           -MM-       |
|       `MM/                                /////             /MM`       |
|        dMh                              /////               yMd        |
|        /MM-                           /////                .MM/        |
|         hMd                         /////                  dMh         |
|         `mMy                      /////                   yMm`         |
|          .mMh`                  ///\\\\\\                  `hMm.          |
|           `hMm-               /////\\\\\\\\\\               -mMh`           |
|             +NMy.           //////  \\\\\\\\\\\\           `yMN+             |
|              `yMMs.        /////      \\\\\\\\\\         .sMMy.             |
|                .sNMd+`                          `+dMNs.                |
|                  `/hMMds:`                  `:odMMh/`                  |
|                     `:sdMMNdyo+/:----::+oyhNMMds:`                     |
|                          -/oyhdmNMMMMNmdhyo/-                          |
--------------------------------------------------------------------------
'''